export const MATTER_TYPE_TYPES = {
  MATTER: 0,
  LEAD: 1
} as const;

export type MatterTypeType = typeof MATTER_TYPE_TYPES[keyof typeof MATTER_TYPE_TYPES];

export const VALID_MATTER_TYPE_TYPES: MatterTypeType[] = [
  MATTER_TYPE_TYPES.MATTER,
  MATTER_TYPE_TYPES.LEAD
]; 